import React from 'react'
import style from './inputHeader.module.scss'
import { VegaButton, VegaButtonTypes } from './../../button/Button'

export const InputHeader = ({ label, link }) => {
	return (
		<>
			{(link || label) && (
				<div className={style.heading}>
					{label && (
						<label className={style.label} htmlFor={style.input}>
							{label}
						</label>
					)}
					{link && <VegaButton type={VegaButtonTypes.LINK} {...link} />}
				</div>
			)}
		</>
	)
}
